<div class="agpr-favoriteColorsPreferences">
    <!-- Header with Add Button -->
    <div class="agpr-favoriteColorsPreferences-header">
        <ng-content></ng-content>
        @if (canAddMore) {
            <agpr-button
                class="agpr-favoriteColorsPreferences-addBtn"
                icon="fa-regular fa-duotone fa-square-plus"
                tooltip="UserPreferences.favoriteColors.addNew.tooltip"
                tooltipPosition="left"
                ariaLabel="UserPreferences.favoriteColors.addNew.tooltip"
                (click)="startAddingColor()"
                [style]="buttonTypesEnum.icon"
            ></agpr-button>
        }
    </div>

    <!-- Empty State -->
    @let hasColors = colorItems.length > 0;
    @if (!hasColors) {
        <div class="agpr-favoriteColorsPreferences-empty">
            <span class="agpr-favoriteColorsPreferences-emptyMessage">
                {{ 'UserPreferences.favoriteColors.noColors' | localize }}
            </span>
        </div>
    }

    <!-- Color List -->
    <ul class="agpr-favoriteColorsPreferences-list"
        agprListKeyboardNavigation
        [focusOnChild]="true"
        [list]="colorItems"
        focusableElementCustomSelector=".agpr-advancedColorPickerField-value"
    >
        <!-- Colors -->
        @for (item of colorItems; track item; let i = $index) {
            <li class="agpr-favoriteColorsPreferences-item"
                [class.agpr-favoriteColorsPreferences-item--duplicated]="item.duplicated"
            >
                <agpr-color-picker-field
                    [id]="id + '_FavoriteColors_'+ item.color + i"
                    [field]="updateColorModel"
                    [value]="item.color"
                    (changes)="updateColor(i, $event)"
                    (remove)="removeColor(i)"
                ></agpr-color-picker-field>
                @if (item.duplicated) {
                    <agpr-form-message >
                        {{ 'UserPreferences.favoriteColors.duplicated' | localize }}
                    </agpr-form-message>
                }
            </li>
        }
    </ul>
</div>
